import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { DrawerControl } from '../../../drawer/drawerControl';
export const LobbyDrawerControl = () => {
    return _jsx(DrawerControl, {});
};
